import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><polygon style={{
    fill: "#464655"
  }} points="0,150.069 0,361.931 141.241,256 " /><path style={{
    fill: "#FF4B55"
  }} d="M473.655,88.276H70.621l158.897,123.586H512v-85.241C512,105.443,494.833,88.276,473.655,88.276z" /><path style={{
    fill: "#41479B"
  }} d="M70.621,423.724h403.034c21.177,0,38.345-17.167,38.345-38.345v-85.241H229.517L70.621,423.724z" /><path style={{
    fill: "#73AF00"
  }} d="M56.889,88.276H38.345C17.167,88.276,0,105.443,0,126.621v6.692L154.974,256L0,378.691v6.688  c0,21.177,17.167,38.345,38.345,38.345h18.539L224.146,291.31H512v-70.62H224.148L56.889,88.276z" /><polygon style={{
    fill: "#F5F5F5"
  }} points="85.333,88.276 56.889,88.276 224.148,220.69 512,220.69 512,203.034 230.291,203.034 " /><polygon style={{
    fill: "#FFE15A"
  }} points="0,133.313 0,155.831 126.53,256 0,356.173 0,378.691 154.974,256 " /><polygon style={{
    fill: "#F5F5F5"
  }} points="224.147,291.31 56.884,423.724 85.329,423.724 230.289,308.966 512,308.966 512,291.31 " /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };